import { render, staticRenderFns } from "./GlossaryView.vue?vue&type=template&id=6e12ec84&scoped=true"
import script from "./GlossaryView.vue?vue&type=script&lang=js"
export * from "./GlossaryView.vue?vue&type=script&lang=js"
import style0 from "./GlossaryView.vue?vue&type=style&index=0&id=6e12ec84&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e12ec84",
  null
  
)

export default component.exports